import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=5ca84432&scoped=true&"
import script from "@/views/Groups/Tabs/Steps.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Steps.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/steps.scss?vue&type=style&index=0&id=5ca84432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca84432",
  null
  
)

export default component.exports